<template>
    <b-modal size="xl" :no-close-on-backdrop="true"
             :hide-footer="true"
             @show="onShow"
             :static="true"
             :title="$t('product_or_service')" ref="innermodal">
        <div class="vld-parent" ref="i101" style="min-height: 50px;">
            <div class="form-inline" style="padding-bottom: 10px; display: flex;">
                <div style="width: 20%; margin-right: 10px">
                    <label style="justify-content: start" class="label-control">Search</label>
                    <input style="width: 100%" type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList">
                </div>
                <div style="width: 20%">
                    <label class="label-control" style="justify-content: start">{{$t('category')}}</label>
                    <select class="form-control form-control-sm" style="width: 90%" v-model="query.CategoryId" @change="toList">
                        <option value="">{{$t('all')}}</option>
                        <option v-for="ret in categories" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                    </select>
                </div>
            </div>
            <div>
                <table class="table table-bordered table-striped table-sm no-bor">
                    <thead>
                        <tr>
                            <th>{{ $t('no') }}</th>
                            <th>{{ $t('code') }}</th>
                            <th>{{ $t('name') }}</th>
                            <th>{{ $t('itemtype')}}</th>
                            <th>{{ $t('category') }}</th>
                            <th>{{ $t('uom') }}</th>
                            <th>{{ $t('model') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td>{{index+1}}</td>
                            <td>{{ ret.Num }}</td>
                            <td><a href="javascript:void(0)" @click="$emit('selected', ret)">{{ret.Name}}</a></td>
                            <td>{{ret.ProductTypeId == 1?'ទំនិញ':'សេវា' }}</td>
                            <td>{{ret.CategoryName}}</td>
                            <td>{{ret.UomName}}</td>
                            <td>{{ret.BrandName}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="box-page">
                <span>{{$t('total_record')}}: {{query.Total}}</span>
                <div class="pull-right">
                    <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                                hide-goto-end-buttons
                                @change="paging($event)"/>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    data(){
        return {
            query:{
                Page: 1,
                Total: 0,
                Limit: 20,
                Text: '',
                CompanyId: this.$store.state.company.Id
            },
            records:[],
            categories: [],
        }
    },
    methods: {
        onShow(){
            this.toList();
            this.getItemCategory();
        },
        toList: function(){
            let loading = this.$loading.show({
                container: this.$refs.i101,
                loader: 'dots'
            });
            this.$api().post('item/list', this.query).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Data;
                    this.query.Total = res.data.Total;
                }
            }).finally(function(){ loading.hide();});
        },
        getItemCategory: function() {
            var loading = this.$loading.show();
            this.$api().post('category/list', { CompanyId: this.$store.state.company.Id }).then(res => {
                if (this.$isValid(res)) {
                    this.categories = res.data.Json.Categories;
                }
            }).finally(() => { loading.hide(); });
        },
        paging(e){
            if(this.query.Page != e){
                this.query.Page = e;
                this.toList();
            }
        }
    }
}
</script>
<style scoped>
    .out-border{
        border: 1px solid #ddd !important;
        border-top: none;
    }
</style>
